import Vue from 'vue'

function getBageStatus (status) {
  return {
    bgColor: status === '완납' ? 'healthy' : status === '부분납' ? 'warning' : 'error',
    text: status
  }
}

export default class BadgeCell {
  init (params) {
    this.eGridCell = params.eGridCell
    this.onClickBadge = params.value.onClickBadge
    const { bgColor, text } = getBageStatus(params.value)
    const InitComp = Vue.component('g-badge')
    this.badgeComp = new InitComp({
      propsData: {
        bgColor: bgColor,
        text: text
      }
    }).$mount()

    this.eGui = this.badgeComp.$mount()
    this.eGui.$el.addEventListener('click', this.onClickBadge)
  }

  getGui () {
    this.eGridCell.appendChild(this.eGui.$el)
  }

  destory () {
    this.eGui.$el.parentNode.removeChild(this.eGui.$el)
  }

  refresh (params) {
    const { bgColor, text } = getBageStatus(params.value)
    this.eGui.$props = {
      bgColor, text
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/ag-grid/BadgeCell.js